import React from 'react';
import './Index.css';

const Contact = (props) => {
  return (
    <div className='main'>
      <br/><br/><br/>
      <h1 className='contact-heading'>
      Contact Us
      </h1> <br/>
      <br/><br/>
      <p1 className='contact-text'>
      For any kind of queries please reach out to us.
      </p1><br/><br/>
      <br/><br/>
      <p1 className='contact-text'>
      Phone: 97173 52536
      </p1><br/><br/>
      <br/><br/>
      <p1 className='contact-text'>
      Email: support@wizwack.in
      </p1><br/><br/>
      <br/><br/>
      <p1 className='contact-text'>
      Postal Address: House No-42, Ground Floor, Block-B, Pkt-8, Sector-5, Rohini, New Delhi - 110085
      </p1>
      <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
    </div>
  );
}

export default Contact